<template>
  <div>
    <p v-html="$t(getText, {PROPERNOUN: getLink})"></p>
  </div>
</template>

<script>
import BaseComponent from '@/components/commentsNew/BaseComponent'

export default {
  name: 'curriculumUpdateNotification',
  extends: BaseComponent,
  props: {
    notificationData: {
      type: Object,
      required: true
    },
    itemType: {
      type: String,
      required: true
    }
  },
  computed: {
    getUrl () {
      if (['UnitCurriculum', 'Unit'].includes(this.itemType)) {
        return '/Atlas/Develop/UnitMap/View/Default?UnitID=' + this.notificationData.id + '&YearID=' + this.notificationData.yearId
      }
      return '/Atlas/Browse/View/UnitCalendar?CurriculumMapID=' + this.notificationData.mapId + '&YearID=' + this.notificationData.yearId
    },
    getLink () {
      return `<a href="${this.getUrl}">${this.notificationData.name}</a>`
    },
    getText () {
      if (this.itemType === 'Unit') {
        let verb = 'updated'
        if (this.notificationData.created) {
          verb = 'created'
        } else if (this.notificationData.deleted) {
          verb = 'deleted'
        } else if (this.notificationData.restored) {
          verb = 'restored'
        }
        return 'Unit {PROPERNOUN} was ' + verb
      } else {
        const label = ['UnitCurriculum', 'Unit'].includes(this.itemType) ? 'Unit' : 'Course'
        return `Curriculum and/or attachments in the [${label}] "{PROPERNOUN}" were updated`
      }
    }
  }
}
</script>
